<template>
  <div class="list no-border platform-delimiter">
    <router-link 
    class="item item-link"
    :to="'/gestion/' + type_str + '/new'"
    :disabled="is_new"
    v-no-select>
      <div class="item-primary">
        <i 
        v-if="type_str === 'contact' || type_str === 'contact_externe'"
        class="user"></i>
        <i 
        v-else
        class="institution"
        style="font-size: 1.25rem;"></i>
        <i class="plus"></i>
      </div>
      <div class="item-content">Ajouter</div>
    </router-link>
    <a class="item item-link"
    :disabled="(is_list && selected.length == 0)"
    v-if="is_list || is_edit"
    @click="onDel"
    v-no-select>
      <div class="item-primary">
        <i 
        v-if="type_str === 'contact' || type_str === 'contact_externe'"
        class="user"></i>
        <i 
        v-else
        class="institution"
        style="font-size: 1.25rem;"></i>
        <i class="close"></i>
      </div>
      <div class="item-content">Supprimer</div>
    </a>
    <a class="item item-link"
    v-if="is_list"
    @click="onMerge"
    :disabled="selected.length < 2"
    v-no-select>
      <i class="item-primary merge_type"></i>
      <div class="item-content">Fusionner</div>
    </a>
    <a class="item item-link"
    v-if="is_list && univers >1"
    @click="onUnivers"
    v-no-select>
      <i class="item-primary address-book"></i>
      <div class="item-content">Carnet</div>
    </a>
    <a class="item item-link"
    v-if="is_list"
    @click="onClassify"
    v-no-select>
      <i class="item-primary folder_shared"></i>
      <div class="item-content">Classifier</div>
    </a>
    <a class="item item-link"
    v-if="is_list"
    @click="onExport"
    v-no-select>
      <i class="item-primary arrow-circle-o-down"></i>
      <div class="item-content">Exporter</div>
    </a>
    <a class="item item-link"
    v-if="is_list"
    @click="onPaginationChange"
    v-no-select>
      <div class="item-primary arrow-circle-o-down">
        <v-checkbox
        :value="pagination"
        @click.stop.prevent
        @input="onPaginationChange"
        ></v-checkbox>
      </div>
      <div class="item-content">
      Pagination
      </div>
    </a>
    <a class="item item-link"
    v-if="is_list"
    @click="onSeeAllChange"
    v-no-select>
      <div class="item-primary arrow-circle-o-down">
        <v-checkbox
        :value="seeAll"
        @click.stop.prevent
        @input="onSeeAllChange"
        ></v-checkbox>
      </div>
      <div class="item-content">
      Tout voir
      </div>
    </a>

    <a class="item item-link"
    :disabled="seeAll"
    v-if="is_list && (type_str === 'contact' || type_str === 'contact_externe')"
    @click="onReportChange"
    v-no-select>
      <div class="item-primary arrow-circle-o-down">
        <v-checkbox
        :value="is_report"
        @click.stop.prevent
        @input="onReportChange"
        ></v-checkbox>
      </div>
      <div class="item-content">
      Nouveaux contacts
      </div>
    </a>

  </div>
</template>
<script>
import Vuex from 'vuex'
import List_meta from './List_meta.js'
import typeahead from '../components/utils/typeahead.js'
// import { EventBus } from '../components/event-bus.js'

export default {
  data: function () {
    return {
      // univers: global.univers,
      // search_fields: List_meta.search_fields,
      // search_fields_index: List_meta.search_fields_index,
      // search_modes: List_meta.search_modes,
      // search_modes_index: List_meta.search_modes_index
    }
  },

  computed: {
    ...Vuex.mapGetters({
      selected: 'listSelection',
      pagination: 'listPagination',
      seeAll: 'listSeeAll',
      is_report: 'listIs_report',
      univers: 'univers',
      items: 'listItems',
    }),

    type_str: function () {
      return this.$route.params.type
    },

    is_new: function () {
      return !!this.$route.fullPath.match(/\/new/)
    },

    is_edit: function () {
      return !!this.$route.fullPath.match(/\/edit/)
    },

    is_list: function () {
      return !!this.$route.fullPath.match(/^\/gestion\/[^/]+\/?$/)
    },

    modal_merge_open: {
      get () {
        return this.$store.getters.listMergeModalState
      },
      set (value) {
        this.$store.commit('ListSetMergeModalState', value)
      }
    },
    merge_main_id: {
      get () {
        return this.$store.getters.listMergeMainId
      },
      set (value) {
        this.$store.commit('ListSetMergeMainId', value)
      }
    },
    merge_items: {
      get () {
        return this.$store.getters.merge_items
      },
      set (items) {
        this.$store.commit('ListSetMergeItems', items)
      }
    },
  },

  methods: {
    ...Vuex.mapActions({
      getList: 'get_list',
      del_contacts: 'del_contacts',
      del_contact: 'del_contact',
    }),

    onDel: function () {
      var vm = this

      if (typeof this.$route.params.contact_id !== 'undefined') {
        this.del_contact(this.$route.params.contact_id)
        .then(function () {
          vm.$router.push('/gestion/' + vm.$route.params.type)
        })
      }
      else if (this.selected.length > 0) {
        this.del_contacts()
        .then(function () {

        })
      }
    },

    onMerge: function () {
      // console.log('onMerge')
      let vm = this

      let merge_items = []

      vm.items.forEach(function(item){
        if(item.selected) {
          merge_items.push(item)
        }
      })

      this.merge_items = merge_items
      this.merge_main_id = null

      this.modal_merge_open = true
    },

    onClassify: function () {
      this.$store.commit('ListSetActionModalState', true)
    },

    onUnivers: function () {
      this.$store.commit('ListSetUniversModalState', true)
    },

    onExport: function () {
      this.$store.commit('ListSetExportModalState', true)
    },

    onPaginationChange: function () {
      this.$store.commit('ListSetData', [])
      this.$store.commit('ListSetPage', 1)
      this.$store.commit('ListSetPagination', !this.pagination)
      this.getList(true)
    },

    onSeeAllChange: function () {
      this.$store.commit('ListSetData', [])
      this.$store.commit('ListSetPage', 1)
      this.$store.commit('ListSetSeeAll', !this.seeAll)
      this.getList(true)
    },

    onReportChange: function () {
      this.$store.commit('ListSetData', [])
      this.$store.commit('ListSetPage', 1)
      this.$store.commit('ListSetReport', !this.is_report)
      this.getList(true)
    },

    onSplitEmail: function (herit) {
      let contact_id = this.$route.params.contact_id
      let vm = this
      this.$store.dispatch('split_emails', {
        contact_id: contact_id,
        herit: (herit) ? 1 : 0
      })
      .then(function () {
        // vm.getList()
        vm.$router.push('/gestion/' + vm.$route.params.type)
      },
      function () {
        console.log('error')
      })
    }
  },
  mounted () {
  }
}
</script>

<style>
.search_item i {
  font-size: 1rem;
  color: #34495e;
}
.search_item .dropdown_display {
  /*padding: 0.25rem;*/
}

.item.item-link {
  overflow: visible;
}
</style>
